/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../types/schema.generated';

import gql from 'graphql-tag';
import { LineRichMenuEditPageContentLineRichMenuPayloadFragmentDoc } from './LineRichMenuEditPageContent.generated';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type ChatRoomStatus =
  /** 要対応(OA向けに作ったものだが、一般にも使えるようなenumにする) */
  | 'ActionRequired'
  /** 面談済み・対応中 */
  | 'Appointed'
  /** 対応不要 */
  | 'Archived'
  /** 契約済み */
  | 'ContractConcluded'
  /** 保険契約済み */
  | 'ContractConcludedInsurance'
  /** 証券契約済み */
  | 'ContractConcludedSecurities'
  /** 不満足の表明(OA向けに作ったものだが、一般にも使えるようなenumにする) */
  | 'GotComplaints'
  /** 後追い対応 */
  | 'Keeping'
  /** 失注 */
  | 'LostOrder'
  /** チャット対応中 */
  | 'Messaging'
  /** 未設定 */
  | 'NotDefined'
  /** 面談設定中 */
  | 'Offering'
  /** 初回面談実施待ち */
  | 'WaitingForFirstAppointment';

export type LineRichMenuActionType =
  | 'LINK'
  | 'TEXT';

export type LineRichMenuStatus =
  | 'PUBLISHED'
  | 'UNPUBLISHED';

export type TargetType =
  | 'ALL_FRIENDS'
  | 'ALL_MATCHED_USERS'
  | 'SEGMENT';

export type LineRichMenuEditPageQueryVariables = Exact<{
  guid: string | number;
}>;


export type LineRichMenuEditPageQuery = { lineRichMenu: { lineRichMenu: { guid: string, label: string, status: Types.LineRichMenuStatus, templateName: string, backgroundImageFileName: string, chatBarText: string, isDisplayDefault: boolean, targetType: Types.TargetType, templateActions: Array<{ __typename: 'LineRichMenuTemplateAction', panelName: string, actionType: Types.LineRichMenuActionType, url: string | null, label: string | null, text: string | null }>, segment: { conditions: Array<
          | { __typename: 'SegmentConditionClickURLCondition', not: boolean, url: string }
          | { __typename: 'SegmentConditionEnqueteAnswered', enqueteGUID: string, not: boolean }
          | { __typename: 'SegmentConditionInflowSource', inflowSourceDefinitionGUID: string, not: boolean }
          | { __typename: 'SegmentConditionLoginLink', not: boolean }
          | { __typename: 'SegmentConditionRoomStatus', status: Types.ChatRoomStatus, not: boolean }
        > } | null } } };


export const LineRichMenuEditPageDocument = gql`
    query LineRichMenuEditPage($guid: ID!) {
  lineRichMenu(guid: $guid) {
    lineRichMenu {
      ...LineRichMenuEditPageContentLineRichMenuPayload
    }
  }
}
    ${LineRichMenuEditPageContentLineRichMenuPayloadFragmentDoc}`;

/**
 * __useLineRichMenuEditPageQuery__
 *
 * To run a query within a Vue component, call `useLineRichMenuEditPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useLineRichMenuEditPageQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useLineRichMenuEditPageQuery({
 *   guid: // value for 'guid'
 * });
 */
export function useLineRichMenuEditPageQuery(variables: LineRichMenuEditPageQueryVariables | VueCompositionApi.Ref<LineRichMenuEditPageQueryVariables> | ReactiveFunction<LineRichMenuEditPageQueryVariables>, options: VueApolloComposable.UseQueryOptions<LineRichMenuEditPageQuery, LineRichMenuEditPageQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<LineRichMenuEditPageQuery, LineRichMenuEditPageQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<LineRichMenuEditPageQuery, LineRichMenuEditPageQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<LineRichMenuEditPageQuery, LineRichMenuEditPageQueryVariables>(LineRichMenuEditPageDocument, variables, options);
}
export function useLineRichMenuEditPageLazyQuery(variables?: LineRichMenuEditPageQueryVariables | VueCompositionApi.Ref<LineRichMenuEditPageQueryVariables> | ReactiveFunction<LineRichMenuEditPageQueryVariables>, options: VueApolloComposable.UseQueryOptions<LineRichMenuEditPageQuery, LineRichMenuEditPageQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<LineRichMenuEditPageQuery, LineRichMenuEditPageQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<LineRichMenuEditPageQuery, LineRichMenuEditPageQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<LineRichMenuEditPageQuery, LineRichMenuEditPageQueryVariables>(LineRichMenuEditPageDocument, variables, options);
}
export type LineRichMenuEditPageQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<LineRichMenuEditPageQuery, LineRichMenuEditPageQueryVariables>;